module.exports = __webpack_public_path__ + "static/media/cases_3d_06c.03c65ef6.jpg";